import { useProperty } from '@spotify-internal/remote-config-integration-react';
import { profileProtectionExtendedBeta } from '@lib/remoteConfig/properties';

export const useProfileProtectionExtendedBeta = () => {
  const isExtendedBetaEnabled = useProperty(profileProtectionExtendedBeta);

  return { isExtendedBetaEnabled };
};
